import styled, { css } from "styled-components";
import { Link as RouterLink } from "react-router-dom";

import {
  ITextProps,
  TextStyles
} from "../Text/Text";
import {
  IButtonProps,
  ButtonStyles
} from "../Button/Button";

export interface ILinkProps extends ITextProps {
  type?: "underlined" | "none";
}

export type ILinkButtonProps = IButtonProps;

export const Link = styled(RouterLink)<ILinkProps>`
  ${TextStyles};
  text-decoration: none;
  line-height: 1.7;
  ${({ color }) => (color ? `color: ${color}` : "")};

  ${({ type }) =>
    type === "underlined" ?
      css`
          text-decoration: underline;
          &:hover {
            text-decoration: none;
          }
        ` :
      ""}
`;

export const ButtonLink = styled(RouterLink)<ILinkButtonProps>`
  ${ButtonStyles};
  text-decoration: none;
  line-height: 35px;
`;

export default Link;
